import {Injectable} from '@angular/core';
import {Http, Headers} from '@angular/http';

@Injectable()
export class GetAddressService {
  placesApi = 'https://maps.googleapis.com/maps/api/place';
  typeAutocomplete = '/autocomplete';
  outJson = '/json';
  mapKey = 'AIzaSyDf1UU4Zz6Z-c-6_bv-zOel5_yCYxtjTQE';

  constructor(private http: Http) {
  }

  autocomplete(input) {
    return this.http.get(this.placesApi + this.typeAutocomplete + this.outJson
      + '?key=' + this.mapKey + '&input=' + input + '&components=country:RO')
      .map(res => res.json());
  }

}
